//// Application Packages
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    updateAccountAuxiliary,
    selectAccount,
} from '../../reducers/accountSlice'

//// Application Components

//// Carbon Components
import { Checkbox } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const CheckUserIDComponent = () => {
    //////// Hooks
    const dispatch = useDispatch()

    //////// State
    const [checked, setChecked] = useState(false)

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const accountData = useSelector(selectAccount)

    //// Slice Data
    const digital_name = settingsData?.['page']?.['digital_name']

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    // Handle Setting Of Checkbox On Load
    const handleSetStateChecked = () => {
        const checked = accountData?.[digital_name]?.auxiliary?.checked
        if (checked) {
            setChecked(checked)
        } else {
            setChecked(false)
        }
    }

    // Handle Addition Or Removal Of Primary Contact Account
    const handleAddSubtUserIdFld = async () => {
        if (accountData?.[digital_name]?.auxiliary?.checked) {
            dispatch(
                updateAccountAuxiliary({
                    digital_name: digital_name,
                    auxiliary: {
                        checked: false,
                    },
                })
            )
            setChecked(false)
        } else {
            dispatch(
                updateAccountAuxiliary({
                    digital_name: digital_name,
                    auxiliary: {
                        checked: true,
                    },
                })
            )
            setChecked(true)
        }
    }

    //////// Memoization

    //////// Effects/Side Effects

    // Check Settings & Set Checkbox On Load
    useEffect(() => {
        handleSetStateChecked()
        return () => {}
    }, [])

    //////////////// Render & Return
    return (
        <>
            <nav className="half-width-checkbox-with-paragraph-group">
                <div className="half-width-checkbox-with-paragraph-group-item">
                    <p>User ID Same As Email</p>
                </div>
                <div className="half-width-checkbox-with-paragraph-group-item">
                    <fieldset className="cds--fieldset">
                        <Checkbox
                            className="fldoh-checkbox"
                            labelText=""
                            id="AddSubtUserIdFld"
                            type="checkbox"
                            checked={checked}
                            onClick={handleAddSubtUserIdFld}
                            role="checkbox"
                            aria-checked="false"
                            tabIndex="0"
                            aria-label="AddSubtUserIdFld"
                            title="AddSubtUserIdFld"
                        />
                    </fieldset>
                </div>
            </nav>
        </>
    )
}

export default CheckUserIDComponent
